import {
  ICreatePalletsRequest,
  IGetAllProductResponse,
  IGetProductByIdResponse,
  IPaginationRequest,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";

export const prefix = PREFIX.masterData;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_GET_ALL_PALLETS = getUrl("get-all-pallets");
const URL_CREATE_PALLET = getUrl("create-pallets");

class PalletApiService extends BaseApiService {
  public getAllPallets = (request: IPaginationRequest) =>
    this.get<IGetAllProductResponse>(URL_GET_ALL_PALLETS, {
      params: request,
    });
  public createPallets = (request: ICreatePalletsRequest) =>
    this.post<ICreatePalletsRequest, IGetProductByIdResponse>(
      URL_CREATE_PALLET,
      request
    );
}

export default new PalletApiService();
